// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__exb6l","card_4":"Card_card_4__2mo_N","card_3":"Card_card_3__1pATA","card_2":"Card_card_2__ezQrc","card_1":"Card_card_1__3Js2H","text":"Card_text__1LUvm"};